import {
	getappletset,
	insertappletset,
	updateappletset,
	getSourceControl,
	putSourceControl,
	getEffective,
	mktdiningeffective,
	addMktdiningeffective,
	updateMktdiningeffective,
	addEffective,
	editEffective,
	delEffective,
	getmgrrole,
	addmgrrole,
	deletemgrrole,
	editemgrrole,
	coderole,
	getmgrmgruser,
	addmgrmgruser,
	changepassword,
	editemgruser,
	deletemgruser,
	getshebeiAll,
	getMeal,
	addMeal,
	putMeal,
	delMeal,
	delMealshebei,
	getShebei,
	getShebeiXiaofeiji,
	getShebeiNew,
	putShebei,
	addShebei,
	delShebei,
	getShebeiDetail,
	getMealdetail,
	delPrinter,
	deleteappletset,
	getDishes,
	addDishesindex,
	getDisheslabel,
	getcardsysinfo,
	insertupcardsysinfo,
	getallkoukuan,
	// addkoukuan,
	getkoukuanway,
	getcustkoukuanway,
	updatekoukuan,
	updatekoukuanPiliang,
	getChupinState,
	specialMchbind,
	putSpecialmchbind,
	getcanteencust,
	updatecolorformation,
	getadminlist,
	getNonghang,
	getTableware,
	getCanjuid,
	addtableware,
	updatetableware,
	deletetableware,
	postNonghang,
	disableDoor,
	getDatahunterauthority,
	addDatahunterauthority,
	editDatahunterauthority,
	delDatahunterauthority,
	resetPerson,
	getMenuaiconfig,
	addMenuaiconfig,
	editMenuaiconfig,
	delMenuaiconfig,
	initDevice,
	getLoginTypes,
	addHoliday,
	getHoliday,
	syncHoliday,
	delHoliday,
	changeCaipin,
	getmenurecipe,
	uploadEmptyplate,
	delEmptyplate,
	getEmptyplate,
	getZidian,
	activeShebei,
	getGonghang,
	updateGonghang,
	timeShebei,
	creatPerson,
	getIconList,
	initIcon,
	editIcon,
	jlzjBindplate,
	getDingding,
	addDingding,
	editDingding,
	delDingding,
	useDingdingIdentity,
	getRegistInfo,
	getRegistDishesNum,
	getCangku,
	dataMoveServer,
	testLinkApi,
	getDSrecord,
	getTailorPhoto,
	goPrecheck,
	goMerchantLnformation,
	goMerchantApplication,
	getPaymentWithhold,
	getCaipuInfo,
	getGlobalSystems,
	getMgrmenu,
	addMgrmenu,
	updateMgrmenu,
	delMgrmenu,
	getSystemMenuTree,
	getRoleTree,
	getMyDecoration,
	updateMyDecoration
	// editHoliday
} from '@/api/baseotherset'
import { getdeductionList, adddeduction } from '@/api/account_v3'

const state = {
	globalBaseSettingsByType: {},
	globalBaseSettings: {},
	globalSystems: [],
	globalSystemsById: {}
}
const mutations = {
	setGlobalBaseSettings (state, preload) {
		state.globalBaseSettingsByType[preload.settingType] = preload
		Object.assign(state.globalBaseSettings, preload, { settingTypes: (state.globalBaseSettings.settingTypes || []).concat([preload.settingType]) })
	},
	setGlobalSystems (state, preload) {
		state.globalSystems = Object.keys(preload).map(item => ({
			id: item,
			name: preload[item]
		}))
		state.globalSystemsById = preload
	}
}

const actions = {
	// editHoliday({ }, data) {
	//   return new Promise((resolve, reject) => {
	//     editHoliday(data).then(res => {
	//       resolve(res)
	//     }).catch(error => {
	//       reject(error)
	//     })
	//   })
	// },
	getCangku ({}, data) {
		return new Promise((resolve, reject) => {
			getCangku(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getIconList ({}, data) {
		return new Promise((resolve, reject) => {
			getIconList(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	initIcon ({}, data) {
		return new Promise((resolve, reject) => {
			initIcon(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editIcon ({}, data) {
		return new Promise((resolve, reject) => {
			editIcon(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	creatPerson ({}, data) {
		return new Promise((resolve, reject) => {
			creatPerson(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	timeShebei ({}, data) {
		return new Promise((resolve, reject) => {
			timeShebei(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delHoliday ({}, data) {
		return new Promise((resolve, reject) => {
			delHoliday(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	syncHoliday ({}, data) {
		return new Promise((resolve, reject) => {
			syncHoliday(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getHoliday ({}, data) {
		return new Promise((resolve, reject) => {
			getHoliday(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addHoliday ({}, data) {
		return new Promise((resolve, reject) => {
			addHoliday(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getLoginTypes ({}, data) {
		return new Promise((resolve, reject) => {
			getLoginTypes(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	initDevice ({}, data) {
		return new Promise((resolve, reject) => {
			initDevice(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	resetPerson ({}, data) {
		return new Promise((resolve, reject) => {
			resetPerson(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	disableDoor ({}, data) {
		return new Promise((resolve, reject) => {
			disableDoor(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getadminlist ({}, data) {
		return new Promise((resolve, reject) => {
			getadminlist(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getChupinState ({}, data) {
		return new Promise((resolve, reject) => {
			getChupinState(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getMeal ({}, data) {
		return new Promise((resolve, reject) => {
			getMeal(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delMealshebei ({}, data) {
		return new Promise((resolve, reject) => {
			delMealshebei(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delMeal ({}, data) {
		return new Promise((resolve, reject) => {
			delMeal(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addMeal ({}, data) {
		return new Promise((resolve, reject) => {
			addMeal(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	putMeal ({}, data) {
		return new Promise((resolve, reject) => {
			putMeal(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getMealdetail ({}, data) {
		return new Promise((resolve, reject) => {
			getMealdetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getShebeiDetail ({}, data) {
		return new Promise((resolve, reject) => {
			getShebeiDetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getShebei ({}, data) {
		return new Promise((resolve, reject) => {
			getShebei(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getShebeiXiaofeiji ({}, data) {
		return new Promise((resolve, reject) => {
			getShebeiXiaofeiji(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getShebeiNew ({}, data) {
		return new Promise((resolve, reject) => {
			getShebeiNew(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addShebei ({}, data) {
		return new Promise((resolve, reject) => {
			addShebei(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delShebei ({}, data) {
		return new Promise((resolve, reject) => {
			delShebei(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	putShebei ({}, data) {
		return new Promise((resolve, reject) => {
			putShebei(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getshebeiAll ({}, data) {
		return new Promise((resolve, reject) => {
			getshebeiAll(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getmgrmgruser ({}, data) {
		return new Promise((resolve, reject) => {
			getmgrmgruser(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addmgrmgruser ({ }, data) {
		return new Promise((resolve, reject) => {
			addmgrmgruser(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	changepassword ({}, data) {
		return new Promise((resolve, reject) => {
			changepassword(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editemgruser ({ }, data) {
		return new Promise((resolve, reject) => {
			editemgruser(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	deletemgruser ({}, data) {
		return new Promise((resolve, reject) => {
			deletemgruser(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	coderole ({}, data) {
		return new Promise((resolve, reject) => {
			coderole(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	getmgrrole ({}, data) {
		return new Promise((resolve, reject) => {
			getmgrrole(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addmgrrole ({}, data) {
		return new Promise((resolve, reject) => {
			addmgrrole(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	deletemgrrole ({}, data) {
		return new Promise((resolve, reject) => {
			deletemgrrole(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editemgrrole ({}, data) {
		return new Promise((resolve, reject) => {
			editemgrrole(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	delEffective ({}, data) {
		return new Promise((resolve, reject) => {
			delEffective(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editEffective ({}, data) {
		return new Promise((resolve, reject) => {
			editEffective(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addEffective ({}, data) {
		return new Promise((resolve, reject) => {
			addEffective(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updateMktdiningeffective ({}, data) {
		return new Promise((resolve, reject) => {
			updateMktdiningeffective(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addMktdiningeffective ({}, data) {
		return new Promise((resolve, reject) => {
			addMktdiningeffective(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	mktdiningeffective ({}, data) {
		return new Promise((resolve, reject) => {
			mktdiningeffective(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getEffective ({}, data) {
		return new Promise((resolve, reject) => {
			getEffective(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	getappletset ({}, data) {
		return new Promise((resolve, reject) => {
			getappletset(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	insertappletset ({}, data) {
		return new Promise((resolve, reject) => {
			insertappletset(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	updateappletset ({}, data) {
		return new Promise((resolve, reject) => {
			updateappletset(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	getSourceControl ({}, data) {
		return new Promise((resolve, reject) => {
			getSourceControl(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	putSourceControl ({}, data) {
		return new Promise((resolve, reject) => {
			putSourceControl(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delPrinter ({}, data) {
		return new Promise((resolve, reject) => {
			delPrinter(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	deleteappletset ({}, data) {
		return new Promise((resolve, reject) => {
			deleteappletset(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDishes ({}, data) {
		return new Promise((resolve, reject) => {
			getDishes(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addDishesindex ({}, data) {
		return new Promise((resolve, reject) => {
			addDishesindex(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDisheslabel ({}, data) {
		return new Promise((resolve, reject) => {
			getDisheslabel(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getcardsysinfo ({}, data) {
		return new Promise((resolve, reject) => {
			getcardsysinfo(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	insertupcardsysinfo ({}, data) {
		return new Promise((resolve, reject) => {
			insertupcardsysinfo(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	addkoukuan ({}, data) {
		return new Promise((resolve, reject) => {
			adddeduction(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getdeductionList ({}, data) {
		return new Promise((resolve, reject) => {
			getdeductionList(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getallkoukuan ({}, data) {
		return new Promise((resolve, reject) => {
			getallkoukuan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	getcustkoukuanway ({}, data) {
		return new Promise((resolve, reject) => {
			getcustkoukuanway(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	getkoukuanway ({}, data) {
		return new Promise((resolve, reject) => {
			getkoukuanway(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updatekoukuanPiliang ({}, data) {
		return new Promise((resolve, reject) => {
			updatekoukuanPiliang(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updatekoukuan ({}, data) {
		return new Promise((resolve, reject) => {
			updatekoukuan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	specialMchbind ({}, data) {
		return new Promise((resolve, reject) => {
			specialMchbind(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	putSpecialmchbind ({}, data) {
		return new Promise((resolve, reject) => {
			putSpecialmchbind(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getcanteencust ({}, data) {
		return new Promise((resolve, reject) => {
			getcanteencust(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updatecolorformation ({}, data) {
		return new Promise((resolve, reject) => {
			updatecolorformation(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getNonghang ({}, data) {
		return new Promise((resolve, reject) => {
			getNonghang(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	postNonghang ({}, data) {
		return new Promise((resolve, reject) => {
			postNonghang(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getTableware ({}, data) {
		return new Promise((resolve, reject) => {
			getTableware(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getCanjuid ({}, data) {
		return new Promise((resolve, reject) => {
			getCanjuid(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addtableware ({}, data) {
		return new Promise((resolve, reject) => {
			addtableware(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updatetableware ({}, data) {
		return new Promise((resolve, reject) => {
			updatetableware(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	deletetableware ({}, data) {
		return new Promise((resolve, reject) => {
			deletetableware(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDatahunterauthority ({}, data) {
		return new Promise((resolve, reject) => {
			getDatahunterauthority(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addDatahunterauthority ({}, data) {
		return new Promise((resolve, reject) => {
			addDatahunterauthority(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editDatahunterauthority ({}, data) {
		return new Promise((resolve, reject) => {
			editDatahunterauthority(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delDatahunterauthority ({}, data) {
		return new Promise((resolve, reject) => {
			delDatahunterauthority(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getMenuaiconfig ({}, data) {
		return new Promise((resolve, reject) => {
			getMenuaiconfig(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addMenuaiconfig ({ }, data) {
		return new Promise((resolve, reject) => {
			addMenuaiconfig(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editMenuaiconfig ({ }, data) {
		return new Promise((resolve, reject) => {
			editMenuaiconfig(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delMenuaiconfig ({}, data) {
		return new Promise((resolve, reject) => {
			delMenuaiconfig(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	changeCaipin ({}, data) {
		return new Promise((resolve, reject) => {
			changeCaipin(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getmenurecipe ({}, data) {
		return new Promise((resolve, reject) => {
			getmenurecipe(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	uploadEmptyplate ({}, data) {
		return new Promise((resolve, reject) => {
			uploadEmptyplate(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getEmptyplate ({}, data) {
		return new Promise((resolve, reject) => {
			getEmptyplate(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delEmptyplate ({}, data) {
		return new Promise((resolve, reject) => {
			delEmptyplate(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getZidian ({}, data) {
		return new Promise((resolve, reject) => {
			getZidian(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	activeShebei ({}, data) {
		return new Promise((resolve, reject) => {
			activeShebei(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getGonghang ({}, data) {
		return new Promise((resolve, reject) => {
			getGonghang(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updateGonghang ({}, data) {
		return new Promise((resolve, reject) => {
			updateGonghang(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	jlzjBindplate ({}, data) {
		return new Promise((resolve, reject) => {
			jlzjBindplate(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDingding ({}, data) {
		return new Promise((resolve, reject) => {
			getDingding(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addDingding ({}, data) {
		return new Promise((resolve, reject) => {
			addDingding(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editDingding ({}, data) {
		return new Promise((resolve, reject) => {
			editDingding(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delDingding ({}, data) {
		return new Promise((resolve, reject) => {
			delDingding(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	useDingdingIdentity ({}, data) {
		return new Promise((resolve, reject) => {
			useDingdingIdentity(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRegistInfo ({}, data) {
		return new Promise((resolve, reject) => {
			getRegistInfo(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRegistDishesNum ({}, data) {
		return new Promise((resolve, reject) => {
			getRegistDishesNum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	dataMoveServer ({}, data) {
		return new Promise((resolve, reject) => {
			dataMoveServer(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	testLinkApi ({}, data) {
		return new Promise((resolve, reject) => {
			testLinkApi(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDSrecord ({}, data) {
		return new Promise((resolve, reject) => {
			getDSrecord(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getTailorPhoto ({}, data) {
		return new Promise((resolve, reject) => {
			getTailorPhoto(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	goPrecheck ({}, data) {
		return new Promise((resolve, reject) => {
			goPrecheck(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	goMerchantLnformation ({}, data) {
		return new Promise((resolve, reject) => {
			goMerchantLnformation(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	goMerchantApplication ({}, data) {
		return new Promise((resolve, reject) => {
			goMerchantApplication(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getPaymentWithhold ({}, data) {
		return new Promise((resolve, reject) => {
			getPaymentWithhold(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getCaipuInfo ({}, data) {
		return new Promise((resolve, reject) => {
			getCaipuInfo(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getGlobalSystems ({ state, commit }) {
		if (state.globalSystems.length) return
		return new Promise((resolve, reject) => {
			getGlobalSystems()
				.then((res) => {
					commit('setGlobalSystems', res)
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getMgrmenu ({}, data) {
		return new Promise((resolve, reject) => {
			getMgrmenu(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addMgrmenu ({}, data) {
		return new Promise((resolve, reject) => {
			addMgrmenu(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updateMgrmenu ({}, data) {
		return new Promise((resolve, reject) => {
			updateMgrmenu(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delMgrmenu ({}, data) {
		return new Promise((resolve, reject) => {
			delMgrmenu(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getSystemMenuTree ({}, data) {
		return new Promise((resolve, reject) => {
			getSystemMenuTree(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRoleTree ({}, data) {
		return new Promise((resolve, reject) => {
			getRoleTree(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getMyDecoration ({}, data) {
		return new Promise((resolve, reject) => {
			getMyDecoration(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updateMyDecoration ({}, data) {
		return new Promise((resolve, reject) => {
			updateMyDecoration(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
